var $01e38e0d24e067b8$exports = {};
$01e38e0d24e067b8$exports = {
  "help": "Ajuda",
  "info": "Informa\xE7\xE3o"
};
export { $01e38e0d24e067b8$exports as default };